<template>
  <div>
    <v-card flat class="ma-6 pa-6 elevation-0" outlined>
      <div class="filter-wrapper">
        <div class="filter-options">
          <v-row>
            <v-col cols="12">
              <GradeClassStudentSelect @changed="gradeClassStudentChange" />
            </v-col>
          </v-row>
        </div>
        <div class="filter-submit">
          <v-btn class="search-button" @click="search" outlined>
            Tìm kiếm
          </v-btn>
        </div>
      </div>
    </v-card>
    <PostCreateStudentDataTable ref="student-data-table" @sendPost="data => $emit('sendPost', data)" />
  </div>
</template>

<script>
// import get from 'lodash-es/get'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import PostCreateStudentDataTable from '@/modules/contactBook/PostCreateStudentDataTable.vue'

export default {
  components: { GradeClassStudentSelect, PostCreateStudentDataTable },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {}
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    search() {
      const params = {}
      // if (this.selectedGrade) params['grade'] = get(this.selectedGrade, 'id')
      if (this.selectedClass) {
        if (this.selectedClass.type === 'extraCurriculum') {
          const studentIds = this.selectedClass.students
          params['id_in'] = studentIds
        } else {
          params['classes'] = this.selectedClass.id
        }
      }
      if (this.selectedStudent) params['id'] = this.selectedStudent.id
      this.$refs['student-data-table'].searchStudents(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
